<template>
  <section class="subheader" :style="{ background: color }">
    <div class="container">
      <h2>{{ title }}</h2>
      <ul>
        <li>
          <router-link to="/">{{ titlePrevious }}</router-link>
        </li>
        <li v-if="isNgo">
          <router-link :to="`/ngo/${$route.params.id}`"> المنظمة </router-link>
        </li>
        <li>{{ title }}</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: ["title", "titlePrevious", "color", "isNgo"],
};
</script>
